<template>
  <v-speed-dial
    v-model="fab"
    fixed
    bottom
    right
    direction="top"
    transition="slide-y-reverse-transition"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="red" dark fab>
        <v-icon>menu</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
    </template>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fab dark small color="red" @click="$router.go(-1)" v-on="on">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      <span>Back</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fab dark small color="red" @click="$router.push('/')" v-on="on">
          <v-icon>home</v-icon>
        </v-btn>
      </template>
      <span>Home</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          small
          color="red"
          @click="$router.push('/user-guide')"
          v-on="on"
        >
          <v-icon>menu_book</v-icon>
        </v-btn>
      </template>
      <span>User Guide</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          small
          color="red"
          @click="$router.push('/wrestler/add')"
          v-on="on"
        >
          <v-icon>person_add</v-icon>
        </v-btn>
      </template>
      <span>Add Wrestler</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          small
          color="red"
          @click="$router.push('/match/add')"
          v-on="on"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Add Match</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fab dark small color="red" @click="logout" v-on="on">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </template>
      <span>Log Out</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
import { getAuth, signOut } from "firebase/auth";

export default {
  name: "NavigationMenu",
  data: () => ({
    fab: false,
  }),
  methods: {
    async logout() {
      const auth = getAuth();
      try {
        await signOut(auth);
        this.$router.push("/login");
      } catch (_e) {}
    },
  },
};
</script>
